import { render, staticRenderFns } from "./CreditCardsBlock.vue?vue&type=template&id=950d0dee&scoped=true&"
import script from "./CreditCardsBlock.vue?vue&type=script&lang=ts&"
export * from "./CreditCardsBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950d0dee",
  null
  
)

export default component.exports